import { useDispatch } from 'react-redux'
import { setDrawer, setStage } from 'slices/drawer'
import { Button } from 'components'
import { STATICS } from 'statics'
import { DRAWER_KEY, NEW_VIRTUAL_SUPPORT_STAGES } from 'app-constants'
import { SignalInfo } from '../signal-info'
import './style.scss'

export function StableSignal() {
  const dispatch = useDispatch()
  function handleBackButton() {
    dispatch(setDrawer(DRAWER_KEY.NONE))
  }

  function handleChatClick() {
    dispatch(setStage(NEW_VIRTUAL_SUPPORT_STAGES.REDIRECT_CHAT))
  }

  return (
    <div className='stable-signal'>
      <SignalInfo icon={STATICS.SIGNAL_CHECK} iconAlt='Sinal estável' title='Sinal estável'>
        <p className='description'>Não identificamos nenhuma anormalidade em sua rede.</p>
        <p className='description'>
          Ainda continua com problema? Se desejar, podemos continuar seu atendimento pelo nosso
          chat. Clique abaixo
        </p>
      </SignalInfo>
      <div className='actions-container'>
        <Button className='button-component -large' color='primary' onClick={handleBackButton}>
          Voltar
        </Button>
        <Button
          className='button-component -large'
          color='primary'
          outlined
          onClick={handleChatClick}
        >
          Falar com atendimento
        </Button>
      </div>
    </div>
  )
}
